import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { ProductForm } from "@/features/products";
import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreateProduct = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (payload) => {
    try {
      await apiClient.post("products/bulk", payload);
      navigate(-1);
    } catch (error) {
      const errorResponse = error?.response?.data?.meta?.error;
      const errorMessage =
        errorResponse && "products.skuPrefix" in errorResponse
          ? "Terdapat SKU Produk yang sama"
          : getErrorMessage(error, "Gagal membuat produk");

      showSnackbar(errorMessage);
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Tambah Produk"
      breadcrumbs={[
        { title: "Produk Umum", path: "/inventory/products" },
        { title: "Tambah" },
      ]}
    >
      <ProductForm
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
